import { IconProps } from ".";
import Icon from "./assets/doc_download_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24DocDownload(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
